import {NgModule} from '@angular/core';
import {SigninComponent} from './signin/signin.component';
import {SignupComponent} from './signup/signup.component';
import {AuthRoutingModule} from './auth-routing.module';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {AuthService} from './auth.service';
import {environment} from '../../environments/environment';

import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  SocialAuthServiceConfig,
  SocialLoginModule
} from '@abacritt/angularx-social-login';
import { SignupFbComponent } from './signup-fb/signup-fb.component';
import { SignupGoogleComponent } from './signup-google/signup-google.component';


@NgModule({
  declarations: [
    SigninComponent,
    SignupComponent,
    SignupFbComponent,
    SignupGoogleComponent
  ],
  imports: [
    AuthRoutingModule,
    FormsModule,
    HttpClientModule,
    SocialLoginModule
  ],
  providers: [
    AuthService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleAppID)
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.facebookAppID)
          }
        ]
      } as SocialAuthServiceConfig
    }
  ],
  exports: [
    SignupFbComponent,
    SignupGoogleComponent
  ]
})
export class AuthModule {}
